import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, computed, ElementRef, HostListener, Input, Signal, signal, OnInit } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-search',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './form-search.component.html',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0, transform: 'translateY(0)' }), animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))]),
      transition(':leave', [animate('100ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class FormSearchComponent implements OnInit {
  private _control: FormControl = new FormControl();

  @Input() set control(value: AbstractControl<any, any> | null) {
    this._control = (value as FormControl) ?? new FormControl();
  }

  @Input() id!: string;
  @Input() label!: string;
  @Input() options!: Signal<Map<number, string>>;
  @Input() placeholder = 'Seleccione una opción';
  @Input() defaultValue: number | null = null;

  filteredOptions = computed(() => {
    const term = this.searchTerm().toLowerCase();
    return this.transformOptions(this.options()).filter((option) => option.value.toLowerCase().includes(term));
  });
  isOpen = signal<boolean>(false);
  searchTerm = signal<string>('');

  get control(): FormControl {
    return this._control;
  }

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.setInitialValue();

    this.control.valueChanges.subscribe((value) => {
      if (!value) {
        this.searchTerm.set('');
      } else {
        this.searchTerm.set(this.options().get(value) ?? '');
      }
    });
  }

  private setInitialValue() {
    const value = this.control.value;
    this.searchTerm.set(value ? (this.options().get(value) ?? '') : '');
  }

  transformOptions(options: Map<number, string>): { key: number; value: string }[] {
    const transformed = Array.from(options, ([key, value]) => ({ key, value }));

    return transformed;
  }

  toggleDropdown() {
    this.isOpen.set(!this.isOpen());
  }

  onSearch(event: Event) {
    const target = event.target as HTMLInputElement;
    this.searchTerm.set(target.value);
  }

  selectOption(key: number, value: string) {
    this.handleSingleSelection(key);
  }

  private handleSingleSelection(key: number) {
    this.setValue(key);
    this.isOpen.set(false);
  }

  private setValue(value: number | null) {
    this._control.setValue(value);
    this.searchTerm.set(this.options().get(value!) ?? '');
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
    }
  }
}
